// extracted by mini-css-extract-plugin
export default {"uploadContainer":"style_uploadContainer__9imXh","viewButton":"style_viewButton__-3GFq","reportButton":"style_reportButton__dOtAc"};